import React from 'react';
import './Headline.css';

export const Headline = () => {
  return (
    <h2 tabIndex="-1">What&#39;s making you happy right now?</h2>
  )
}